import moneybox from './assets/moneybox.png';
import devices from './assets/devices.png';
import hourglass from './assets/hourglass.png';
import repeat from './assets/repeat.png';
import statistics from './assets/statistics.png';
import activity from './assets/activity.png';

export const whyUsItems = [
  {
    title: 'Это бесплатно',
    description:
      'С RS Lang у вас есть доступ к обучению и мини-играм абсолютно бесплатно!',
    img: moneybox,
  },
  {
    title: 'Доступность с любого устройства',
    description: 'Обучение доступно на смартфоне, планшете или ноутбуке.',
    img: devices,
  },
  {
    title: 'Эффективная методика обучения',
    description:
      'В RS Lang используется одна из лучших методик обучения - интервальное повторение.',
    img: hourglass,
  },
  {
    title: 'Мини-игры',
    description:
      'Закрепление пройденного материала с помощью интересных, увлекательных мини-игр.',
    img: repeat,
  },
  {
    title: 'Статистика прогресса',
    description:
      'Отслеживание прогресса обучения с помощью понятной и наглядной статистики.',
    img: statistics,
  },
  {
    title: 'Увлекательный процесс',
    description:
      'Сочетание аудио, картинок и распознавания речи позволит запомнить слова гораздо быстрее!',
    img: activity,
  },
];
